import { z } from "zod";
export const CreateFeedbackInvitationSchema = z.object({
    sessionId: z.guid(),
    contactId: z.guid(),
});
export const FeedbackInvitationResultSchema = z.object({
    id: z.guid(),
});
export const GetFeedbackInvitationSchema = z.object({
    firstName: z.string().nullable(),
});
